import { useState } from 'react';
import { importExportAPI } from '../services/api';

export default function Import() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [sqlInput, setSqlInput] = useState('');
  const [groupId, setGroupId] = useState('');

  const handleCSVUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setLoading(true);
      setError(null);
      const data = await importExportAPI.importCSV(file);
      setResult(data);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSQLImport = async () => {
    if (!sqlInput.trim() || !groupId.trim()) {
      setError('SQL schema and Group ID are required');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const data = await importExportAPI.importSQL(
        sqlInput,
        parseInt(groupId, 10)
      );
      setResult(data);
      setSqlInput('');
      setGroupId('');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      const blob = await importExportAPI.exportCSV();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'data-dictionary-export.csv';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Import & Export</h1>
        <p className="mt-2 text-gray-600">Import data from CSV or SQL, or export to CSV</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* CSV Import */}
        <div className="card">
          <h2 className="text-xl font-semibold mb-4">Import from CSV</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select CSV File
              </label>
              <input
                type="file"
                accept=".csv"
                onChange={handleCSVUpload}
                disabled={loading}
                className="input"
              />
            </div>
            {result && (
              <div className="bg-green-50 border border-green-200 rounded p-4">
                <p className="text-sm text-green-800">
                  Successfully imported {result.inserted} entries
                </p>
              </div>
            )}
          </div>
        </div>

        {/* SQL Import */}
        <div className="card">
          <h2 className="text-xl font-semibold mb-4">Import from SQL</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Group ID
              </label>
              <input
                type="number"
                value={groupId}
                onChange={(e) => setGroupId(e.target.value)}
                placeholder="Enter group ID"
                className="input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                SQL CREATE TABLE Statement
              </label>
              <textarea
                value={sqlInput}
                onChange={(e) => setSqlInput(e.target.value)}
                placeholder="CREATE TABLE ..."
                rows={8}
                className="input font-mono text-sm"
              />
            </div>
            <button
              onClick={handleSQLImport}
              disabled={loading || !sqlInput.trim() || !groupId.trim()}
              className="btn btn-primary w-full"
            >
              {loading ? 'Importing...' : 'Import SQL'}
            </button>
          </div>
        </div>

        {/* Export */}
        <div className="card md:col-span-2">
          <h2 className="text-xl font-semibold mb-4">Export to CSV</h2>
          <button onClick={handleExport} className="btn btn-primary">
            Export All Entries
          </button>
        </div>
      </div>

      {error && (
        <div className="mt-6 bg-red-50 border border-red-200 rounded p-4">
          <p className="text-sm text-red-800">Error: {error}</p>
        </div>
      )}
    </div>
  );
}

